module.exports = __webpack_public_path__ + "static/img/zhongzhongka22.eccb590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka22.png
// module id = 70FD
// module chunks = 16